IMPERSONATE
<input (change)="impersonate($event)" type="text" placeholder="email + ENTER" class="impersonate-input">
<button (click)="impersonate()" color="primary">Töröl</button>
